module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>arrow</title><path d=\"M49.33,26.8a2.26,2.26,0,0,0-.35-1L39.44,14.19a1.63,1.63,0,0,0-2.24-.24,1.59,1.59,0,0,0-.25,2.18l7.49,9.12H3.17a1.55,1.55,0,1,0,0,3.11H44.43l-7.49,9.12a1.58,1.58,0,0,0,2.49,1.94L49,27.77a1.4,1.4,0,0,0,.35-1Z\"/></svg>";


//////////////////
// WEBPACK FOOTER
// ./src/shared/templates/arrow.html
// module id = 513
// module chunks = 1